import { render, staticRenderFns } from "./IconUpload.vue?vue&type=template&id=33dd3b62&scoped=true&"
import script from "./IconUpload.vue?vue&type=script&lang=ts&"
export * from "./IconUpload.vue?vue&type=script&lang=ts&"
import style0 from "./IconUpload.vue?vue&type=style&index=0&id=33dd3b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dd3b62",
  null
  
)

export default component.exports